<template>
  <vs-row vs-justify="center" >
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="10">
      <b-card title-color="primary">
        <component v-bind:is="resolvedType" />
      </b-card>
    </vs-col>
  </vs-row>
</template>
<script>

import { mapGetters } from 'vuex';

import { MACHALI } from '@/constants/companies';
import SV from '@/febos/global/customDocuments/vistas/empresas/61808000-5/SV';
import ADP from '@/febos/global/customDocuments/vistas/empresas/61808000-5/ADP';
import SP from '@/febos/global/customDocuments/vistas/empresas/72235100-2/SP';
import SCP from '@/febos/global/customDocuments/vistas/empresas/72235100-2/SCP';
import BIT from '@/febos/global/customDocuments/vistas/empresas/72235100-2/BIT';
import OF from '@/febos/global/customDocuments/vistas/empresas/72235100-2/OF';
import OFCORE from '@/febos/global/customDocuments/vistas/empresas/72235100-2/OFCORE';
import RES from '@/febos/global/customDocuments/vistas/empresas/72235100-2/RES';
import MEMO from '@/febos/global/customDocuments/vistas/empresas/72235100-2/MEMO';
import ODP from '@/febos/global/customDocuments/vistas/empresas/72235100-2/ODP';
import RESUGDPS from '@/febos/global/customDocuments/vistas/empresas/72235100-2/RESUGDPS';
import INF from '@/febos/global/customDocuments/vistas/empresas/72235100-2/INF';
import ACUCORE from '@/febos/global/customDocuments/vistas/empresas/72235100-2/ACUCORE';
import AF from '@/febos/global/customDocuments/vistas/empresas/61221000-4/AF';
import SCH from '@/febos/global/customDocuments/vistas/empresas/61980520-8/SCH';
import CPSH from '@/febos/global/customDocuments/vistas/empresas/61980520-8/CPSH';
import FISABS from '@/febos/global/customDocuments/vistas/empresas/61980520-8/FISABS';
import SOGR from '@/febos/global/customDocuments/vistas/empresas/72235100-2/SOGR';
import SEGR from '@/febos/global/customDocuments/vistas/empresas/72235100-2/SEGR';
import IDPC from '@/febos/global/customDocuments/vistas/empresas/72235100-2/IDPC';
import GRC from '@/febos/global/customDocuments/vistas/empresas/61980520-8/GRC';
import SCF from '@/febos/global/customDocuments/vistas/empresas/61980520-8/SCF';
import ACT from '@/febos/global/customDocuments/vistas/empresas/61980520-8/ACT';
import FCA from '@/febos/global/customDocuments/vistas/empresas/61980520-8/FCA';
import DA from '@/febos/global/customDocuments/vistas/empresas/69080200-7/DA';
import OFMachali from '@/febos/global/customDocuments/vistas/empresas/69080200-7/OF';
import MEMOMachali from '@/febos/global/customDocuments/vistas/empresas/69080200-7/MEMO';
import RESINH from '@/febos/global/customDocuments/vistas/empresas/61211000-K/RESINH';

export default {
  name: 'CreateDocument',
  props: {
  },
  data() {
    return {
      type: this.$route.params.type,
    };
  },
  components: {
    GRC,
    SV,
    ADP,
    SP,
    SCP,
    BIT,
    OF,
    RES,
    MEMO,
    ODP,
    RESUGDPS,
    ACUCORE,
    OFCORE,
    INF,
    SCH,
    CPSH,
    FISABS,
    SOGR,
    SEGR,
    IDPC,
    AF,
    SCF,
    ACT,
    FCA,
    DA,
    OFMachali,
    MEMOMachali,
    RESINH
  },
  mounted() {
    console.log(this.$route.params.type);
  },
  methods: {

  },
  computed: {
    ...mapGetters('Empresas', ['company']),
    resolvedType() {
      if (this.type === 'OF' && this.company.iut === MACHALI.iut) {
        return 'OFMachali';
      }
      if (this.type === 'MEMO' && this.company.iut === MACHALI.iut) {
        return 'MEMOMachali';
      }
      return this.type;
    }
  }
};
</script>
